import { useContext, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Header from './Header';
import useConfig from 'hooks/useConfig';
import NavigationScroll from 'components/NavigationScroll';
import FloatingActionMenu from '../../components/common/FloatingMenu/FloatingActionMenu';
import SubscriptionWall from '../../components/SubscriptionWall/SubscriptionWall';
import StripeConnectBanner from '../../components/StripeConnectBanner/StripeConnectBanner';
import { AuthContext } from '../../context/AuthProvider';

export default function MainLayout() {
  const { themeDirection, customColor, mode, container } = useConfig();
  const { user, meLoading, stripeConnected } = useContext(AuthContext);
  const [showStripeBanner, setShowStripeBanner] = useState(false);

  const isInactive =
    !meLoading &&
    user?.user?.user_type === 'merchant_admin' &&
    user?.restaurant?.subscription_status !== 'active';

  // Show Stripe connect banner once per session for unconnected merchants
  useEffect(() => {
    if (meLoading) return;
    if (user?.user?.user_type !== 'merchant_admin') return;
    if (stripeConnected !== false) return;
    if (sessionStorage.getItem('stripe_banner_shown')) return;
    sessionStorage.setItem('stripe_banner_shown', '1');
    setShowStripeBanner(true);
  }, [meLoading, stripeConnected, user?.user?.user_type]);

  return (
    <div data-pc-preset={customColor} data-pc-direction={themeDirection} data-pc-theme={mode}>
      <Drawer />
      <Header />
      <div className="pc-container">
        <div className={`pc-content ${container && 'container'} `}>
          <NavigationScroll>
            {!isInactive && <Outlet />}
          </NavigationScroll>
        </div>
        {!isInactive && <FloatingActionMenu />}
      </div>
      <SubscriptionWall isInactive={isInactive} />
      <StripeConnectBanner
        show={showStripeBanner}
        onHide={() => setShowStripeBanner(false)}
        context="login"
      />
    </div>
  );
}
